export const SRR_PROMISE_NAMES = {
    SME_PARTNERS_DETAIL: 'SME_PARTNERS_DETAIL',
    SME_PARTNERS_CATALOG: 'SME_PARTNERS_CATALOG',
    SME_PARTNERS_SIMILAR: 'SME_PARTNERS_SIMILAR',
    SME_PARTNERS_SELECTIONS: 'SME_PARTNERS_SELECTIONS',
};
